import { render, staticRenderFns } from "./ResellerPendingPlans.vue?vue&type=template&id=ea64bcf6&"
import script from "./ResellerPendingPlans.vue?vue&type=script&lang=js&"
export * from "./ResellerPendingPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports